import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Layout, Typography, Card, Form, Input, Row, Col, Spin } from "antd";
import { useNavigate } from "react-router-dom";

// PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appLabel from "../../../config/appLabel";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, staticConfig } from "../systemAdmin.config";
import cnt from "../../../services/definedConstant";
import CustomButton from "../../../components/custom/CustomButton";

const { Text, Title } = Typography;

const EditSmsService = (props) => {
  const { userData } = props;
  const { session } = userData;

  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getSmsServiceConfig();
  }, []);

  /** ---------------------------
   * GET SMS SERVICE CONFIGURATION
   * -------------------------- */
  const getSmsServiceConfig = () => {
    setIsLoading(true);

    const url = `${apiConfig.ExternalServiceSMS}/SMS`;
    const body = { session };

    BOM.FetchReqAction(body, url, (err, res) => {
      setIsLoading(false);

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage);
        return;
      }

      const formatted = {};
      (res || []).forEach((item) => {
        if (!formatted[item.name]) {
          formatted[item.name] = item.value || "";
        }
      });

      form.setFieldsValue({
        host_name: formatted.host_name || "",
        port_number: formatted.port_number || "",
        end_point: formatted.end_point || "",
        tenant_app_key: formatted.tenant_app_key || "",
      });
    });
  };


  const onFinish = (values) => {
    setIsLoading(true);

    const url = `${apiConfig.ExternalServiceSMS}/SMS`;
    const body = {
      session,
      method: "PUT",
      ...values, // spread form values directly into the body
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      setIsLoading(false);

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage);
      } else {
        BOM.AlertMsg(
          cnt.SUCCESS,
          "SMS Service Configuration Updated Successfully"
        );
        navigate("/sya2800");
      }
    });
  };

  const onCancel = () => {
    navigate("/sya2800");
  };

  return (
    <MainLayout>
      <TopContent
        pageTitle={"Edit Smtp Service Configuration"}
        pageItems={staticConfig.editExternalNotifcationSmsBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {appLabel.generalInfo}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item
                    name="host_name"
                    label={<Text strong>Host Name</Text>}
                    rules={[
                      { required: true, message: "Host Name is required" },
                    ]}
                  >
                    <Input placeholder="Host Name" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="port_number"
                    label={<Text strong>Port Number</Text>}
                    rules={[
                      { required: true, message: "Port Number is required" },
                    ]}
                  >
                    <Input placeholder="Port Number" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="end_point"
                    label={<Text strong>End Point</Text>}
                    rules={[
                      { required: true, message: "End Point is required" },
                    ]}
                  >
                    <Input placeholder="End Point" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="tenant_app_key"
                    label={<Text strong>Tenant App Key</Text>}
                  >
                    <Input placeholder="Tenant App Key" />
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="end">
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginRight: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
                <CustomButton
                  htmlType="submit"
                  content="Submit"
                  style={{ width: "10%" }}
                  onClick={onFinish}
                />
              </Row>
            </Card>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps)(EditSmsService);
